import Router from './domain/Router';
import { ClientsProvider } from './context/ClientContext';
import { ExperiencesProvider } from './context/ExperienceContext';
import { CaseStudiesProvider } from './context/CaseStudyContext';
import AnalyticsGate from './consent/AnalyticsGate';
import ConsentBanner from './consent/ConsentBanner';
import { ConsentProvider } from './consent/ConsentProvider';

const App = () => (
    <ConsentProvider>
        <AnalyticsGate />
        <ExperiencesProvider>
            <CaseStudiesProvider>
                <ClientsProvider>
                    <Router />
                </ClientsProvider>
            </CaseStudiesProvider>
        </ExperiencesProvider>
        <ConsentBanner />
    </ConsentProvider>
);

export default App;
